import { CalcFtHeadAction, CalcFtHeadState } from 'src/modules/user-input/calcFtHead/types.ts';
import { initialState } from 'src/modules/user-input/calcFtHead/initialState.ts';

export const reducer = (prevState: CalcFtHeadState, action: CalcFtHeadAction): CalcFtHeadState => {
    let newState = { ...prevState };
    if (action.type === 'mediumParams_change') {
        newState = {
            ...newState,
            density: action.payload.density,
        };
    }
    if (action.type === 'ftHead_change') {
        newState = {
            ...newState,
            ftHead: action.payload,
        };
    }
    if (action.type === 'reset') {
        newState = {
            ...initialState,
        };
    }

    return newState;
};
